export const ForgotPasswordFormConstants = {
    StoreSliceName: "ForgotPasswordForm",
  };
  